<po-page-default
  [p-breadcrumb]="breadcrumb"
  [p-title]="'Inventariar - ' + codigoInventario"
>

  <div class="po-row po-mb-2">
    <po-info class="po-md-3" p-label="Área" [p-value]="area"></po-info>
    <po-info class="po-md-3" p-label="Lotes Bipados" [p-value]="nLotesBipados.toString()"></po-info>
    <po-info class="po-md-3" p-label="Total de Lotes" [p-value]="itens.length.toString()"></po-info>
  </div>

  <div class="po-row po-mb-2">
    <po-input
      class="po-md-4"
      [p-auto-focus]="true"
      name="lote"
      [(ngModel)]="lote"
      p-label="Lote (Bipar)"
      (keyup.enter)="bipar()"
    ></po-input>
    <po-button
      class="po-md-3 po-mt-4"
      p-label="Fechar Área"
      p-kind="primary"
      (p-click)="abrirFecharArea()"
    ></po-button>
  </div>

  <div class="po-row">
    <po-table
      class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="itens"
      [p-columns]="colunas"
      p-spacing="small"
      [p-height]="500"
      [p-sort]="true"
      [p-hide-columns-manager]="true"
    ></po-table>
  </div>

</po-page-default>

<po-modal
  #areaModal
  p-title="Informe a Área"
  [p-primary-action]="confirmarArea"
  [p-hide-close]="true"
>
  <form #f="ngForm">
    <po-input
      class="po-md-12"
      [p-auto-focus]="true"
      name="area"
      [(ngModel)]="area"
      p-label="Área"
      [p-required]="true"
      [p-maxlength]="10"
    ></po-input>
  </form>
</po-modal>

<po-modal
  #fecharAreaModal
  p-title="Fechar Área"
  [p-primary-action]="fecharArea"
  [p-secondary-action]="cancelarFechar"
>
  <div class="po-row">
    <po-info class="po-md-6" p-label="Total de Lotes" [p-value]="itens.length.toString()"></po-info>
    <po-info class="po-md-6" p-label="Lotes Bipados" [p-value]="nLotesBipados.toString()"></po-info>
  </div>
  <form #ff="ngForm">
    <po-number
      class="po-md-12 po-mt-2"
      [p-auto-focus]="true"
      name="qtdBipadaConfirmacao"
      [(ngModel)]="qtdBipadaConfirmacao"
      p-label="Quantos lotes você bipou?"
    ></po-number>
  </form>
</po-modal>
